import { render, staticRenderFns } from "./tinyEditor.vue?vue&type=template&id=647f7fca&scoped=true&"
import script from "./tinyEditor.vue?vue&type=script&lang=js&"
export * from "./tinyEditor.vue?vue&type=script&lang=js&"
import style0 from "./tinyEditor.vue?vue&type=style&index=0&id=647f7fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f7fca",
  null
  
)

export default component.exports